import { render, staticRenderFns } from "./cgly.vue?vue&type=template&id=50899d06&scoped=true&"
import script from "./cgly.vue?vue&type=script&lang=js&"
export * from "./cgly.vue?vue&type=script&lang=js&"
import style0 from "./cgly.vue?vue&type=style&index=0&id=50899d06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50899d06",
  null
  
)

export default component.exports